/**
 * The one copy of each legal document is on the marketing site
 * (marketing/src/app/privacy, marketing/src/app/terms). Every link in the app
 * points there; the app's own /privacy and /terms redirect there (and nginx
 * 301s them on app.unipostudio.com). Platform reviewers and the Google OAuth
 * consent screen are given these same URLs.
 *
 * The Meta data deletion status page (ROUTES.DATA_DELETION) stays in the app.
 */
export const PRIVACY_POLICY_URL = 'https://unipostudio.com/privacy';
export const TERMS_OF_SERVICE_URL = 'https://unipostudio.com/terms';

/** Where a customer writes for help: the address the marketing site publishes. */
export const SUPPORT_EMAIL = 'support@unipostudio.com';
